import getters from './getters';
import actions from './actions';
import mutations from './mutations';
var state = function state() {
  return {
    seller: null
  };
};
export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};